import React from 'react';
import classNames from 'classnames';
import css from './ListingCardSkeleton.module.css';

const ListingCardSkeleton = ({ className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.imageWrapper}>
        <div className={css.imageSkeleton} />
      </div>
      <div className={css.info}>
        <div className={css.priceSkeleton} />
        <div className={css.titleSkeleton} />
        <div className={css.titleSkeletonShort} />
        <div className={css.authorSkeleton} />
      </div>
    </div>
  );
};

export default ListingCardSkeleton;
